<avi-state-page class="licensing-page">
    <avi-state-page_main-content>
        <!--ERRORS-->
        <avi-alert-group
            *ngIf="error"
            alertType="danger"
        >
            {{ error }}
        </avi-alert-group>

        <licensing-page-header
            (onLicenseTierChangeRequest)="openTierChangeModal()"
            (onTabSelect)="handleTabSelect($event)"
            [enterpriseWithCloudServicesLicenseStatus]="saasStatus$ | async"
        ></licensing-page-header>

        <!--License Add Alert Message-->
        <avi-alert-group
            *ngIf="licenseAddAlert?.message && !hideLicenseAlert"
            [alertType]="licenseAddAlert?.type"
            [closable]="true"
            (onAlertClose)="closeLicenseAlert()"
        >
            <span>{{ licenseAddAlert?.message }}</span>
        </avi-alert-group>

        <!--Overview Tab Content-->
        <ng-container *ngIf="activeTab === licensingTabActions.OVERVIEW">
            <div class="licensing-page__overview-content">
                <div class="licensing-page__overview-row">
                    <!--GET STARTED Section-->
                    <div class="licensing-page__overview-col">
                        <avi-content-loading-container
                            aviMediumSpinner
                            [isLoading]="tierChangeInProgress$ | async"
                        >
                            <licensing-get-started
                                *ngIf="!(isLicensingServiceConnected$ | async)"
                                (onConnectToCloudLicensing)="handleConnectToCloudLicensing($event)"
                                (onUseOnPremLicensingService)="handleUseOnPremLicensingService()"
                                (onLicenseTierChangeRequest)="openTierChangeModal()"
                                (onError)="handleStatusCardError($event)"
                            ></licensing-get-started>
                            <licensing-page-status-card
                                *ngIf="isLicensingServiceConnected$ | async"
                                [headerTitle]="licenseStatusCardTitle"
                                (onLicenseTypeChangeModal)="openTierChangeModal()"
                                (onError)="handleStatusCardError($event)"
                            ></licensing-page-status-card>
                        </avi-content-loading-container>
                    </div>

                    <!--LICENSE USAGE Section-->
                    <div class="licensing-page__overview-col">
                        <avi-content-loading-container
                            aviMediumSpinner
                            [isLoading]="(loadingLicenseUsage$ | async) || (tierChangeInProgress$ | async)"
                        >
                            <div
                                class="licensing-page__license-card"
                                *ngIf="defaultLicenseTier"
                            >
                                <license-card
                                    [availableServiceCores]="availableServiceCores$ | async"
                                    [isBusy]="false"
                                    [licenseTier]="defaultLicenseTier"
                                    [licenseTierTitle]="licenseTierTitle"
                                    [orgServiceUnits]="serviceUnits$ | async"
                                    [licensePool]="licensePool$ | async"
                                    [reservedServiceCores]="reservedServiceCores$ | async"
                                    [reserveServiceUnits]="reserveServiceUnits"
                                    [usedServiceCores]="usedServiceCores$ | async"
                                ></license-card>
                            </div>
                        </avi-content-loading-container>
                    </div>
                </div>

                <!--LICENSES-->
                <div class="licensing-page__license-list">
                    <ng-container *ngrxLet="shouldHideLicenseList$ as shouldHideLicenseList">
                        <license-list
                            *ngIf="!shouldHideLicenseList"
                            [licenses]="licenseList$ | async"
                            [isBusy]="loadingLicenses$ | async"
                            [showRefreshButton]="isEnterpriseTier && (isLicensingServiceConnected$ | async)"
                            [isOnPremLicensingEnabled]="isOnPremLicensingEnabled$ | async"
                            [showAddLicenseButton]="showAddLicense$ | async"
                            [legacyLicenseGracePeriod]="legacyLicenseGracePeriod$ | async"
                            (onReload)="reloadLicenseGrid()"
                            (onRefresh)="handleRefreshLicenses()"
                        ></license-list>
                    </ng-container>
                </div>
            </div>
        </ng-container>

        <!--Tenant Usage Tab Content-->
        <ng-container *ngIf="activeTab === licensingTabActions.TENANT_USAGE">
            <div class="licensing-page__tenant-usage-content">
                <div class="licensing-page__tenant-usage-row">
                    <tenant-usage-list></tenant-usage-list>
                </div>
            </div>
        </ng-container>
    </avi-state-page_main-content>
</avi-state-page>
